export enum ReportStatusOperationEnum {
  DELETE = 'DELETE',
  RESTORE = 'RESTORE',
  DELETE_PERMANENTLY = 'DELETE_PERMANENTLY',
}
